import { NgModule } from "@angular/core";
import { DeliveryBookingStatusChangeModalComponent } from "./delivery-booking-status-change-modal/delivery-booking-status-change-modal.component";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
@NgModule({
  declarations: [DeliveryBookingStatusChangeModalComponent],
  imports: [CommonModule, TranslateModule, FormsModule, ReactiveFormsModule, NgSelectModule],
  exports: [DeliveryBookingStatusChangeModalComponent]
})
export class DeliverySharedComponentsModule {}
